export const mockContributorsData = [
  { id: 1, name: "Lena Hart" },
  { id: 2, name: "Marco Vale" },
  { id: 3, name: "Rina Cole" },
];

export const mockPublishersData = [
  { id: 1, name: "Copyright Control" },
  { id: 2, name: "Northline Publishing" },
  { id: 3, name: "Silver Frame Music" },
];

export const mockShareholdersData = [
  { id: 1, name: "Lena Hart", email: "lena@example.test" },
  { id: 2, name: "Marco Vale", email: "marco@example.test" },
  { id: 3, name: "Rina Cole", email: "rina@example.test" },
];

export const mockTrackCostsData = [
  { id: 1, name: "Mastering" },
  { id: 2, name: "Mixdown" },
  { id: 3, name: "Session Musician" },
];
